module.exports = __webpack_public_path__ + "fonts/NotoSansKR-Regular.9139661f.woff2";